import HeaderReserva from "./Reserva/HeaderReserva";
import DatosReserva from "./Reserva/DatosReserva";
import FooterReduced from "./Reserva/FooterReduced";

const Reserva = (props) => {
    return (
        <div className="booking-process">
            <header-reserva>
                <HeaderReserva
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.propiedad.nombre}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    propiedad={props.propiedad}
                    destino={props.eldestino}
                    destinos={props.destinos}
                    propiedad={props.propiedad}
                    experiencias={props.experiencias}
                ></HeaderReserva>
            </header-reserva>
            <main className="main">
                <DatosReserva
                    propiedad={props.propiedad}
                    precios={props.precios}
                    llegada={props.llegada}
                    salida={props.salida}
                    difdias={props.difdias}
                    adultos={props.adultos}
                    ninos={props.ninos}
                    bebes={props.bebes}
                    lang={props.lang}
                    ruta={props.ruta}
                    config={props.config}
                    tpvs={props.tpvs}
                    paypal={props.paypal}
                    transferencia={props.transferencia}
                    stripes={props.stripes}
                    paycomet={props.paycomet}
                    moneda={props.moneda}
                    numpropiedades={props.numpropiedades}
                    websgrupo={props.websgrupo}
                    cliente={props.cliente}
                />
            </main>
            <footer-reduced>
                <FooterReduced
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </footer-reduced>
        </div>
    );
}

export default Reserva;
